<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type half_int">
					<autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @selected="selectClass" results-display="code_name" :placeholder="'Item / ' + headers.class + ' Name or Code'"> </autocomplete>
				</span>
			</div>
			<div class="left_option" style="padding-top:5px;">
				<span class="int_type_no_border mgr_5">
					<ItemClassSelectMulti v-model.trim="item_classes_string" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big3_tbl">
				<table id="item_list" class="list_tbl tbl_pointer" v-columns-resizable>
					<thead>
						<tr>
							<th style="text-align:center;width:3%;"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
							<th style="text-align:center;width:4%;">Blkd.</th>
							<th style="text-align:center;width:15%;">{{ headers.class }} Code</th>
							<th style="text-align:center;width:15%;">WH Code</th>
							<th style="text-align:center;">{{ headers.class }} Name</th>
						</tr>
					</thead>

					<tbody>
						<tr v-for="item in itemClasses" v-bind:key="item.code" v-bind:class="{ on: item.selected }" @click="selectRow(item)">
							<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
							<td class="al_center">
								<span v-if="item.so_blocked"><font color="red">&#10004;</font></span>
							</td>
							<td>{{ item.code }}</td>
							<td>{{ item.wh_code }}</td>
							<td class="truncate">
								<span :title="item.name">{{ item.name }}</span>
							</td>
						</tr>
					</tbody>
				</table>

				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

				<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

				<div class="view_bottom_bt">
					<a v-if="modifiable" href="javascript:;" class="search_bt mgr_15" @click="block()">Block</a>
					<a v-if="modifiable" href="javascript:;" class="search_bt" @click="unBlockFromList()">UnBlock</a>
				</div>
			</div>

			<div class="right_small3_tbl" style="height:749px;">
				<div>
					<h4 class="inner_h5">Blocked Item {{ headers.class }} List</h4>
					<div class="fixed-table-container" style="height:670px;">
						<!-- <div class="table-wrapper" style="height:410px;"> -->
						<div class="table-wrapper">
							<table id="item_list" class="list_tbl tbl_pointer" border="0">
								<thead>
									<tr>
										<th style="text-align:center;width:2%;">
											<div class="th-text"><input type="checkbox" @change="selectAllBlocked()" v-model="allBlockedSelected" /></div>
										</th>
										<th style="text-align:center;width:15%;">
											<div class="th-text">{{ headers.class }} Code</div>
										</th>
										<th style="text-align:center;width:15%;"><div class="th-text">WH Code</div></th>
										<th style="text-align:center;">
											<div class="th-text">{{ headers.class }} Name</div>
										</th>
									</tr>
								</thead>

								<tbody>
									<!-- <tr v-for="item in items" v-bind:key="item.item_id" v-bind:class="{ on: item.item_id == selectedItem.item_id }" @click="openModal('ItemDetail', item)"> -->
									<tr v-for="item in blockedItemClasses" v-bind:key="item.item_id" v-bind:class="{ on: item.selected }" @click="selectRow(item)">
										<td class="al_center"><input type="checkbox" id="active_yn" v-model="item.selected" /></td>
										<td>{{ item.code }}</td>
										<td>{{ item.wh_code }}</td>
										<td class="truncate">
											<span :title="item.name">{{ item.name }}</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div style="text-align:right;padding-top:5px;padding-right:15px;">Total Count : {{ blockedItemClasses.length | commaSeparated }}</div>
						<div class="view_bottom_bt">
							<a v-if="modifiable" href="javascript:;" class="search_bt mgr_15" @click="unBlock()">UnBlock</a>
							<!-- <a v-if="modifiable" href="javascript:;" class="search_bt" @click="save()">Save</a> -->
							<!-- <a v-if="modifiable" href="javascript:;" :class="!isDeletable ? 'disable_bt' : 'gray_bt'" @click="del()" class="delete_button">Delete</a> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectItemClassList, apiUpdateSoBlockItemClasses } from '@/api/item/class.js';
import _ from 'lodash';
import Paging from '@/components/common/Paging';
// import CodeSelect from '@/components/common/CodeSelect';
// import Modal from '@/components/common/Modal';
// import ItemDetail from '@/components/common/ItemDetail';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import '@/assets/css/table_box.css';

export default {
	data: function() {
		return {
			item_classes_string: '',
			item_classes: [],

			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			keyword: '',

			itemClasses: [],

			blockedItemClasses: [],

			allSelected: false,
			allBlockedSelected: false,
		};
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
	},
	components: {
		Paging,
		ItemClassSelectMulti,
	},
	methods: {
		async block() {
			var selectedClasses = this.itemClasses.filter(i => i.selected);
			if (selectedClasses.length == 0) {
				this.$toast.error('Nothing Selected');
				return false;
			}

			const { data } = await apiUpdateSoBlockItemClasses({
				item_class_list: selectedClasses,
				so_blocked: 1,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				var vm = this;
				selectedClasses.forEach(sc => {
					if (vm.blockedItemClasses.filter(bc => bc.code == sc.code).length == 0) {
						sc.so_blocked = true;
						sc.selected = false;
						vm.blockedItemClasses.push(_.cloneDeep(sc));
					}
					sc.selected = false;
				});
			} else {
				this.$toast.error(data.msg);
			}
		},
		async unBlock() {
			if (this.blockedItemClasses.filter(i => i.selected).length == 0) {
				this.$toast.error('Nothing Selected');
				return false;
			}

			const { data } = await apiUpdateSoBlockItemClasses({
				item_class_list: this.blockedItemClasses.filter(i => i.selected),
				so_blocked: 0,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				var vm = this;
				for (var i = this.blockedItemClasses.length - 1; i >= 0; i--) {
					if (this.blockedItemClasses[i].selected) {
						vm.itemClasses
							.filter(ic => ic.code == this.blockedItemClasses[i].code)
							.forEach(ic => {
								ic.so_blocked = false;
							});
						this.blockedItemClasses.splice(i, 1);
					}
				}
			} else {
				this.$toast.error(data.msg);
			}
		},
		async unBlockFromList() {
			//console.log(this.itemClasses.filter(ic => ic.selected && ic.so_blocked));
			var selectedClasses = this.itemClasses.filter(ic => ic.selected && ic.so_blocked);
			if (selectedClasses.length == 0) {
				this.$toast.error('No Valid Item(s) Selected');
				return false;
			}

			const { data } = await apiUpdateSoBlockItemClasses({
				item_class_list: selectedClasses,
				so_blocked: 0,
			});

			if (data.result) {
				this.$toast.success('Saved successfully');
				var vm = this;
				selectedClasses.forEach(ic => {
					ic.so_blocked = false;
					//ic.selected = false;
					for (var i = vm.blockedItemClasses.length - 1; i >= 0; i--) {
						if (vm.blockedItemClasses[i].code == ic.code) {
							vm.blockedItemClasses.splice(i, 1);
						}
					}
				});
				this.itemClasses
					.filter(ic => ic.selected)
					.forEach(ic => {
						ic.selected = false;
					});
			} else {
				this.$toast.error(data.msg);
			}
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += ', ' + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
			//this.itemClass = c.selectedObject.code;
			//this.search();

			//console.log(c.selectedObject.code);
		},

		search() {
			if (this.item_classes_string) this.item_classes = this.item_classes_string.split(',');
			else this.item_classes = [];
			//console.log(this.item_classes);

			this.selectItemClasses();
		},
		reset() {
			this.page_no = 1;
			this.keyword = '';

			this.item_classes_string = '';
			this.item_classes = [];
			this.allSelected = false;
		},
		async selectItemClasses(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			this.itemClasses = [];
			this.allSelected = false;

			const { data } = await apiSelectItemClassList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				active_yn: 'A',
				closed_yn: 'A',
				item_classes: this.item_classes,
			});

			//console.log(data);
			this.itemClasses = data.itemClassList;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
			//this.$router.replace('/item/item_class?active_yn=' + this.active_yn + 'closed_yn=' + this.closed_yn + '&page_no=' + this.page_no).catch(err => err);

			//if (this.itemClasses.length > 0) this.selectRow(this.itemClasses[0]);
		},

		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectItemClasses(pageNo);
		},
		selectRow(item) {
			if (item.selected) item.selected = false;
			else item.selected = true;

			//console.log(item.checked);
			this.$forceUpdate();
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.itemClasses.forEach(function(item) {
				item.selected = vm.allSelected;
			});
		},

		selectAllBlocked() {
			var vm = this;
			this.blockedItemClasses.forEach(function(item) {
				item.selected = vm.allBlockedSelected;
			});
		},

		async index() {
			const { data } = await apiSelectItemClassList({
				paging_yn: 'N',

				active_yn: 'A',
				closed_yn: 'A',
				so_blocked: true,
			});

			//console.log(data);
			this.blockedItemClasses = data.itemClassList;
		},
	},
	created() {
		//this.$store.sideIndex = 1;
		this.$store.commit('setSideIndex', 1);
		//this.$store.selectedMenu = 'nav_li_1';
		this.$store.commit('setSelectedMenu', 'nav_li_item_block');
		this.$store.commit('setSubTitle', 'Item -> Block Class in Sales Order');

		this.index();
		this.selectItemClasses();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
